export interface IPOSDefaultScreen {
  id: number;
  name: string;
  key: string;
}

export const posDefaultScreen = [
  {
    id: 1,
    name: 'Menu',
    key: 'menu'
  },
  {
    id: 2,
    name: 'Table',
    key: 'table'
  }
]
